import * as React from 'react'

import Text from 'components/ui/text'
import { cn } from 'utils/classMerge'

type PaymentMethodWrapperProps = {
  children: React.ReactNode
  disabledByGB?: boolean
  text?: string
  wrapperClass?: string
}

export const PaymentMethodWrapper = ({
  disabledByGB,
  children,
  text,
  wrapperClass = 'tw-w-full',
}: PaymentMethodWrapperProps) => {
  const margin = disabledByGB ? 'tw-mb-3' : ''
  return (
    <div
      className={cn('tw-relative tw-overflow-visible', margin, wrapperClass)}
    >
      {children}
      {disabledByGB && (
        <Text
          as="div"
          className="xs:tw-absolute tw-mt-1 tw-mb-0 tw-text-nowrap tw-text-zinc-600 tw-text-xs tw-font-normal tw-leading-none tw-text-center tw-mb"
        >
          {text}
        </Text>
      )}
    </div>
  )
}
